/**
 * AI Usage Credit packs — loaded from paymentPlans.canonical.json
 * (must match manage360.me-server via shared/paymentPlans.canonical.json).
 * Live UI prefers GET /orders/plans when the API is reachable.
 */
import canonical from "./paymentPlans.canonical.json";

export const DEFAULT_VOICE_CREDIT_PLANS = canonical.plans.map((p) => ({
  name: p.name,
  amountInRupees: Number(p.amountInRupees),
  tokenCredits: Number(p.creditTokens),
}));

/** Static fallback; same reference as defaults for bundle consumers. */
export const VOICE_CREDIT_PLANS = DEFAULT_VOICE_CREDIT_PLANS;

export const VOICE_CREDIT_BASIC_PLAN = DEFAULT_VOICE_CREDIT_PLANS.find(
  (p) => p.name === "Basic Plan"
);
